import axios from "axios";

//const defaultBaseURL = "http://localhost:8088/api/v1";
const defaultBaseURL = "https://visiga-seminary.com/api/v1";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || defaultBaseURL,
});

export default axiosInstance;

